import { dataUserToShowOnMap } from '../typesActions/types';

export const initialListAction = (data) => {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			try {
				dispatch({
					type: dataUserToShowOnMap.ADD_LIST_DATA_USER_TO_ON_MAP,
					payload: data
				});
				resolve(data); // Retorna a data como resultado da Promise
			} catch (error) {
				reject(error); // Rejeita a Promise em caso de erro
			}
		});
	};
};

export const editListAction = (data) => {
	return {
		type: dataUserToShowOnMap.EDIT_LIST_DATA_USER_TO_ON_MAP,
		payload: data
	};
};

export const deleteListAction = () => {
	return { type: dataUserToShowOnMap.DELETE_LIST_DATA_USER_TO_ON_MAP };
};
